// src/pages/Home.jsx
import React from "react";
import Section from "../components/Section";
import { SERVICES, TESTIMONIALS, PROCESS } from "../utils/constants";
import { FeatureCard, Testimonial } from "../components/Cards";
import { Link } from "react-router-dom";
import hero from "../hero.png"

export default function Home(){
  return (
    <>
      <Section>
        <div className="container-tight grid grid-2-md" style={{alignItems:"center"}}>
          <div>
            <h1 className="h1">Clean installs. Precise tuning. <span style={{color:"var(--primary)"}}>Zero guesswork.</span></h1>
            <p className="muted" style={{marginBottom:24,maxWidth:600}}>Head units, amps, subs, speakers, cameras—installed like OEM, tuned like a studio.</p>
            <div className="row">
              <Link to="/services" className="btn btn-primary">Services & Pricing</Link>
            </div>
            <ul className="list-plain muted small" style={{marginTop:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,maxWidth:520}}>
              <li>Veteran-owned</li><li>Clean hidden wiring</li>
              <li>Pro system tuning</li><li>Satisfaction guarantee</li>
            </ul>
          </div>
          <div><img src={hero} alt="Clean car audio install hero" loading="eager"/></div>
        </div>
      </Section>

      <Section eyebrow="WHAT WE DO" title="Core Services" subtitle="The most requested upgrades, done right.">
        <div className="grid grid-3-md">
          {SERVICES.slice(0,3).map(s=>(
            <FeatureCard key={s.title} Icon={s.icon} title={s.title}>{s.description}</FeatureCard>
          ))}
        </div>
        <div style={{marginTop:16}}>
          <Link to="/services" className="link">Explore all services →</Link>
        </div>
      </Section>

      <Section eyebrow="HOW IT WORKS" title="Our Process" subtitle="Transparent steps from consult to tune.">
        <ol className="grid grid-3-md" style={{gridTemplateColumns:"repeat(4,1fr)"}}>
          {PROCESS.map(p=>(
            <li key={p.step} className="card" style={{padding:20}}>
              <div className="small muted">{p.step}</div>
              <div className="h3" style={{margin:0}}>{p.title}</div>
              <p className="small muted" style={{marginTop:8}}>{p.body}</p>
            </li>
          ))}
        </ol>
      </Section>

      <Section eyebrow="CUSTOMERS" title="Word on the street">
        <div className="grid grid-3-md">
          {TESTIMONIALS.map(t=><Testimonial key={t.name} {...t}/>)}
        </div>
      </Section>

      <Section tight>
        <div className="card" style={{padding:20,display:"flex",gap:16,flexWrap:"wrap",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <div className="h3" style={{margin:0}}>Ready to upgrade?</div>
            <p className="small muted" style={{marginTop:4}}>
              Installs are scheduled by email to ensure accurate quotes and availability.
            </p>
          </div>
          <div className="row">
            <a
              href="mailto:austinlm132@gmail.com?subject=A%20%26%20M%20Audio%20Install%20Request&body=Vehicle%3A%0AWhat%20you%20want%20installed%3A%0AEquipment%20(customer-supplied%20or%20purchased%20through%20A%26M)%3A%0APreferred%20days%2Ftimes%3A%0ALocation%3A"
              className="btn btn-primary"
            >
              Request an Install (Email)
            </a>
            <Link to="/contact" className="btn btn-outline">Contact</Link>
          </div>
        </div>
      </Section>
    </>
  );
}
